__turbopack_context__.v({
  "divider": "gh_xwa_divider",
  "field": "gh_xwa_field",
  "fieldLabel": "gh_xwa_fieldLabel",
  "memberInput": "gh_xwa_memberInput",
  "memberInputAvatar": "gh_xwa_memberInputAvatar",
  "memberInputName": "gh_xwa_memberInputName",
  "removeButton": "gh_xwa_removeButton",
  "section": "gh_xwa_section",
  "skills": "gh_xwa_skills",
  "toggleLabel": "gh_xwa_toggleLabel",
  "toggleRow": "gh_xwa_toggleRow",
});
